import Parse from "parse";

type OD3_Tenant = Parse.Object;

export interface Bikes_AllowedAttributes {
  id: string;
  objectId: string;
  createdAt: Date;
  updatedAt: Date;

  description: string;
  tenant: OD3_Tenant;
  value: number;
}

export class Bikes_Allowed extends Parse.Object<Bikes_AllowedAttributes> {
  static className: string = "OD3_GTFS_Bikes_Allowed";

  constructor(data?: Partial<Bikes_AllowedAttributes>) {
    super("OD3_GTFS_Bikes_Allowed", data as Bikes_AllowedAttributes);
  }

  get description(): string {
    return super.get("description");
  }
  set description(value: string) {
    super.set("description", value);
  }
  get tenant(): OD3_Tenant {
    return super.get("tenant");
  }
  set tenant(value: OD3_Tenant) {
    super.set("tenant", value);
  }
  get value(): number {
    return super.get("value");
  }
  set value(value: number) {
    super.set("value", value);
  }
}

Parse.Object.registerSubclass("OD3_GTFS_Bikes_Allowed", Bikes_Allowed);
